export class UpdateUserSettings {
    public constructor(init?: Partial<UpdateUserSettings>) {
      Object.assign(this, init);
    }
      userId: string;
      lotNumber: string;
   }